import ComponentError from './ComponentError'

export default ComponentError
